import UserAPI from 'api/UserAPI';
import { useAuth } from 'hooks/useAuth';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { catchErrorMessage } from 'utility/helpers';
import { RegistrationFormData } from './useSignupForm';

export function useSignup() {
  const { login } = useAuth();
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submittedValues, setSubmittedValues] = useState<any>(null);

  const onSignUp = useCallback(async (values: RegistrationFormData) => {
    try {
      setLoading(true);
      const body: any = {
        ...values,
        roles: [
          {
            roleName: 'ROLE_COMPANY_USER',
            roleDescription: 'Role Company User',
          },
        ],
        username: values.email.toLowerCase(),
      };
      delete body.confirmPassword;
      const response: any = await UserAPI.signUp(body);
      if (response?.props?.to !== '/login') {
        setStep(1);
        setSubmittedValues(values);
      }
    } catch (e) {
      toast.error(catchErrorMessage(e));
    } finally {
      setLoading(false);
    }
  }, []);

  const onRequestNewCode = () => {
    onSignUp(submittedValues);
  };

  const onVerifyCode = useCallback(
    async (code: string) => {
      try {
        setLoading(true);
        await UserAPI.verifyCode(submittedValues.email, code);
        setStep(2);
      } catch (e) {
        toast.error(catchErrorMessage(e));
      } finally {
        setLoading(false);
      }
    },
    [submittedValues],
  );

  const onLogin = useCallback(async () => {
    login(
      { username: submittedValues.email, password: submittedValues.password },
      {
        onError: (e) => {
          toast.error(catchErrorMessage(e));
        },
      },
    );
  }, [submittedValues]);

  return {
    loading,
    step,
    onLogin,
    onRequestNewCode,
    onSignUp,
    onVerifyCode,
  };
}
